import { render, staticRenderFns } from "./integratedManagement.vue?vue&type=template&id=82dc0af2"
import script from "./integratedManagement.vue?vue&type=script&lang=js"
export * from "./integratedManagement.vue?vue&type=script&lang=js"
import style0 from "./integratedManagement.vue?vue&type=style&index=0&id=82dc0af2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports